import { computed } from 'vue'
import usePerson from '@/hooks/usePerson'
import usePersonSpecificProduct from '@/hooks/usePersonSpecificProduct'

/**
 *  @file useProductPersons contains logic for products involving all persons
 */

const hasSelectedProducts = computed(() => {
  const { persons } = usePerson()
  if (persons.value.length === 0) return false

  return (
    persons.value.filter(person => {
      return (
        Object.keys(person.products.products).filter(productId => person.products.products[productId].selected).length >
        0
      )
    }).length > 0
  )
})

const selectedCategories = computed(() => {
  const { persons } = usePerson()
  const { hasPersonOnlyKVG, hasPersonOnlyVVG } = usePersonSpecificProduct()

  if (persons.value.length > 0) {
    return persons.value.reduce((result, p) => {
      result[p.personId] = {
        isKVGOnly: hasPersonOnlyKVG(p.personId),
        isVVGOnly: hasPersonOnlyVVG(p.personId),
      }
      return result
    }, {})
  }
  return []
})

/**
 *  selectedCategoriesByPerson
 *  @todo same as {@link selectedCategories}, but using personsWithDetails instead of persons
 *
 */
const selectedCategoriesByPerson = computed(() => {
  const { personsWithDetails } = usePerson()
  const { hasPersonOnlyKVG, hasPersonOnlyVVG } = usePersonSpecificProduct()
  return personsWithDetails.value.reduce((result, person) => {
    result[person.personId] = {
      isKVGOnly: hasPersonOnlyKVG(person.personId),
      isVVGOnly: hasPersonOnlyVVG(person.personId),
    }
    return result
  }, {})
})

export default function useProductPersons() {
  return {
    // COMPUTED
    hasSelectedProducts,
    selectedCategories,
    selectedCategoriesByPerson,
  }
}
